import { z } from 'zod';
import { SShift, SShiftType } from '@/api/apis/resources/schedule';
import { ShiftUnavailabilitiesFormType } from './types';

export const getDefaultValues = (shiftData?: SShift): ShiftUnavailabilitiesFormType => {
  return {
    fullDay: shiftData?.shiftType === SShiftType.Unavailable,
    unavailabilities: shiftData?.unavailabilities?.length ? shiftData?.unavailabilities : [{ from: '', to: '' }],
  };
};

const naObject = z.object({
  from: z.iso.datetime({ offset: true }),
  to: z.iso.datetime({ offset: true }),
});

const naSchema = z.object({
  fullDay: z.literal(false),
  unavailabilities: z.array(naObject.required()).nonempty(),
});

const fullDaySchema = z.object({
  fullDay: z.literal(true),
  unavailabilities: z.array(z.any()).optional(),
});

export const sShiftUnavailabilitiesFormSchema = z.discriminatedUnion('fullDay', [naSchema, fullDaySchema]);
